<template>
    <b-modal
        v-model="modalShow"
        class="ext-modal ext-modal--xl"
        title="ファイルの削除"
        cancel-title="キャンセル"
        ok-title="削除"
        ok-variant="danger"
        @ok="deleteFile"
        @hidden="close">
        <div v-if="file !== null">
            <div class="d-flex justify-content-center align-items-center pt-3">
                <template v-if="file.url.slice(-4) === '.pdf'">
                    <b-img
                        src="/images/common/icon_pdf.svg"
                        class="consultation-message-pdf">
                    </b-img>
                </template>
                <template v-else>
                    <img :src="file.presigned_url" class="u-fit">
                </template>
            </div>
            <p class="text-center mt-2">このファイルを完全に削除してもよろしいですか？</p>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'

export default {
    name: 'DeleteFileModal',

    props: {
        userType: {
            type: String,
            required: true,
        },
    },

    data: function () {
        return {
            modalShow: false,
            file: null,
            model: null,
            inProgress: false,
            errors: {},
        }
    },

    created: function () {
        bus.$on('open-modal-delete-file', this.open)
    },

    beforeDestroy: function () {
        this.file = null
        bus.$off('open-modal-delete-file')
    },

    methods: {
        open: function (file, model) {
            this.file = file
            this.model = model
            this.modalShow = true
        },

        close: function () {
            this.file = null
            this.modalShow = false
        },

        /**
         * 削除
         */
        deleteFile: async function() {
            if (this.inProgress) return
            this.inProgress = true

            let endpoint = null

            if (this.model === 'ConsultationMessageImage') {
                if (this.userType === 'user') {
                    endpoint = `${constants.user.consultation_message_images.endpoint.base}/${this.file.id}`
                }
                else if (this.userType === 'doctor') {
                    endpoint = `${constants.doctor.consultation_message_images.endpoint.base}/${this.file.id}`
                }
                else if (this.userType === 'admin') {
                    endpoint = `${constants.admin.consultation_message_images.endpoint.base}/${this.file.id}`
                }
            }

            await axios.delete(endpoint)
                .then(() => {
                    bus.$emit('alert-success', 'ファイルを削除しました。')
                    this.close()
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'ファイルを削除できませんでした。')
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.consultation-message-pdf {
    width: 70px;
}
</style>
